@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.admin.rides
import com.narbase.letsgo.dto.core.KmmLong

import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.ridephonenumber.PhoneNumberDto

object ReorderRideAdminEndpoint
    : EndPoint<ReorderRideAdminEndpoint.Request, ReorderRideAdminEndpoint.Response>() {
    class Request(
        val passengerId: KmmLong,
        val rideId: KmmLong,
        val priceToken: String?,
        val phoneNumberDto: PhoneNumberDto?,
        val isAppRide: Boolean
    )

    class Response(
        val requestId: KmmLong
    )
}